var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(this.settings !== undefined && this.settings.enableArticleList === 1),expression:"this.settings !== undefined && this.settings.enableArticleList === 1"}],staticClass:"article-layer",attrs:{"id":_vm._uid + '-article-layer'}})
}
var staticRenderFns = []

export { render, staticRenderFns }